import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { UserInfo } from "CommonLibrary";
import HealthFile from "../common/HealthFile";
import CapNavigation from "../common/CapNavigation";
// import { authTokenCookie } from '../utils/CookieMaker';
// // import { Environment } from '../utils/Environment';
// import {UserAuthorization} from '../common/Authorization';
// import { userRoleVal } from '../utils/constants';

const TotalCommentsDetails = lazy(() => import('component/containers/totalCommentsDetails/index'))
const CloseTheLoop = lazy(() => import('../component/screens/closeTheLoop'))
const CtlWebForm = lazy(() => import('../component/containers/ctlWebForm'))

// let { userInfo } = authTokenCookie();

const route = (<React.Fragment>
    <Routes>
        <Route path="/health" element={<HealthFile />} />
        <Route path="/CAPcaseupdate" element={<CapNavigation />} />
        <Route path="/" element={<CloseTheLoop />} />
        {/* <Route path="/caseIdForm" element={isAuthorized ?(authUrl && authUrl.includes("caseId") ? <Navigate replace to={authUrl} /> : <CtlWebForm />):<UserAuthorization/>} /> */}
        <Route path="/caseIdForm" element={<CtlWebForm />} />
        <Route path="/totalCommentsDetails" element={<TotalCommentsDetails />} />
        <Route path="/myinfo" element={<UserInfo />} />
    </Routes>
</React.Fragment>
)

export default route
